import { combineReducers } from 'redux';
import Users from './Users';

const globalReducer = combineReducers({
  Users,
});

export default globalReducer;
